import React, { useEffect, useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useFormik } from "formik";
import Select from 'react-select';
import TextInput from "../../common/textfield/TextInput.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../common/Button/index.js";
import { failed, success } from "../../common/Toastify.jsx";
import { FormikObj, FormikObjEdit, fileTypes, deliveryTypes, protocols } from "./Constant.js";
import SelectFiled from "../../common/textfield/SelectFiled.jsx";
import { Tooltip } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { deleteReportDelivery, createReportDelivery, getReportDeliveryById, updateReportDelivery } from "../../api/ReportDeliveries/index.js";
import { decryptData } from "../../EncryptDecrypt.js";
import { use } from "react";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery.js";

function EditReportDelivery(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
  const permissions = useSelector((state) => state?.auth?.user?.permissions);
  const user = useSelector((state) => state?.auth?.user);
  const [reportDeliveryData, setReportDeliveryData] = useState(null);    
  const [organizations, setOrganizations] = useState([]);
  const [orgId, setOrgId] = useState(location?.state?.orgId || adminOrgs[0].id);
  const [btnLoading, setBtnLoading] = useState(false);
  const [isFax, setIsFax] = useState(false);

  useOrgQuery({
      onSuccess: (data) => {
          setOrganizations(data?.map((org) => ({ label: org?.name, value: org?.id }))) 
      },
      refetchOnWindowFocus: false,
  })
      
  const handleOrgChange = (event) => {
      setOrgId(event.value);
      formik.setFieldValue("orgId", event.value)
  }

  const getSelected = (items, value) => {
    return items?.find(item => item.value == value);
  }

  const formik = useFormik({
    ...(props.new ? FormikObj : FormikObjEdit),
    onSubmit: async (values) => {
      setBtnLoading(true);
      try {
        if (values.type === "FAX") {
          values.hostName = "";
          values.protocol = "";
          values.userName = "";
          values.secret = "";
        }

        ((props.new) ? createReportDelivery({...values}) : updateReportDelivery({...values})).then(res => {
          if (res.status === true) {
            navigate("/app/report-deliveries", {state: {orgId}})
            success(res.message);
          } else {
            failed(res.error);
          }
        })
        .catch(err => {
          failed(err?.response?.data?.message || err?.response?.data?.error || err.message);
        })
        .finally(() => setBtnLoading(false));
    }
    catch(err) {
      failed(err?.response?.data?.message || err?.response?.data?.error || err.message);
    }
  }});

  const handleTypeChange = (e) => {
    let value = e.value;
    if(value == "FAX") {
      setIsFax(true);
      formik.setFieldValue("hostName", "");
      formik.setFieldValue("protocol", "");
      formik.setFieldValue("userName", "");
      formik.setFieldValue("secret", "");
    } else {
      setIsFax(false);
    }
    formik.setFieldValue("target", "");
    formik.setFieldValue("type", value)
  }

  // ---------- Init + seed form ----------
  useEffect(() => {
    if (!props.new && location?.state?.id && location?.state?.orgId) {
      const { id, orgId: navOrgId } = location.state;
      setOrgId(navOrgId);

      getReportDeliveryById(id, navOrgId)
        .then(res => {
          console.log("DATA", res);
          if (res?.status && res?.data) {
            const record = Array.isArray(res.data) ? res.data[0] : res.data;

            if (!record) return;

            setReportDeliveryData(record);
            setIsFax(record.type === "FAX");

            formik.setValues({
              id: record.id ?? "",
              type: record.type ?? "",
              protocol: record.protocol ?? "",
              hostName: record.hostName ?? "",
              target: record.target ?? "",
              userName: record.userName ?? "",
              secret: record.secret ?? "",
              fileType: record.fileType ?? "",
              name: record.name ?? "",
              orgId: record.orgId ?? navOrgId,
            });
          }
        })
        .catch(err => failed(err?.response?.data?.message || err?.message || "Failed to load"));
    } else {
      formik.setFieldValue("orgId", orgId);
    }
  }, []);

  return (
    <section className="common-listing">
      <div className="heading-wrap mb-3">
        <Tooltip title="Go back">
          <div
            style={{ marginRight: "1rem", cursor: "pointer" }}
            onClick={() => navigate("/app/report-deliveries", {state: {orgId }})}
          >
            <ArrowBack />
          </div>
        </Tooltip>
        <h1>Report Delivery Details</h1>
      </div>
      <div className="custom-card p-4">
        <form className="common-form border-fields"           
          onSubmit={formik.handleSubmit}>
        
        { organizations.length > 1 &&
            <Row style = {{marginBottom:'30px', marginTop: '20px'}}>
              <Col xs lg="2">
                <label className="searchSelectLabel">
                  Organization<span style={{ color: "red" }}> *</span>{" "}
                </label>
              </Col>
              <Col xs lg="4">
              {props.new 
                ?
                  <Select
                  keyField={"orgId"}
                  formik={formik}
                  label={"Select Organization"}
                  selectLabel="Select Organization"
                  options={organizations}
                  isLoading={organizations?.length >= 1 ? false : true}
                  readOnly={organizations?.length >= 1 ? false : true}
                  hideRequired={true}
                  onChange={handleOrgChange}
                  className="search-select"
                  classNamePrefix="select"
                  placeholder="Select Organization..."
                  value={getSelected(organizations, (formik.values?.orgId || orgId))}
                  />
                : <span>{organizations.find(org => org.value === reportDeliveryData?.orgId)?.label}</span>
              }
              </Col>
            </Row>
        }
        <Row style = {{marginBottom:'10px', marginTop: '0px'}}>
          <Col xs lg="2">
                <label className="searchSelectLabel">
                  Delivery Name<span style={{ color: "red" }}> *</span>{" "}
                </label>
          </Col>
          <Col xs lg="4">
                <TextInput
                      keyField={"name"}
                      formik={formik}
                      placeholder={"Delivery Name"}                                               
                      hideRequired={true}
                      required={true}
                      style={{width: "80%"}}
                />
            </Col>
        </Row>
        <Row style = {{marginBottom:'30px', marginTop: '0px'}}>
          <Col xs lg="2">
                <label className="searchSelectLabel">
                  Delivery Type<span style={{ color: "red" }}> *</span>{" "}
                </label>
          </Col>
          <Col xs lg="4">
              <Select
                  keyField={"type"}
                  formik={formik}
                  label={"Select Delivery Type"}
                  selectLabel="Select Delivery Type"
                  options={deliveryTypes}
                  isLoading={deliveryTypes?.length > 1 ? false : true}
                  readOnly={deliveryTypes?.length > 1 ? false : true}
                  onChange={handleTypeChange}
                  className="search-select"
                  classNamePrefix="select"
                  placeholder="Select Delivery Type..."
                  value={getSelected(deliveryTypes, formik.values.type)}
                  />
            </Col>
        </Row>
        {!isFax && (<Row style = {{marginBottom:'30px', marginTop: '20px'}}>
          <Col xs lg="2">
                <label className="searchSelectLabel">
                  Protocol
                </label>
          </Col>
          <Col xs lg="4">
              <Select
                  keyField={"protocol"}
                  formik={formik}
                  label={"Select Protocol"}
                  selectLabel="Select Protocol"
                  options={protocols}
                  isLoading={protocols?.length > 1 ? false : true}
                  readOnly={protocols?.length > 1 ? false : true}
                  onChange={(value) => formik.setFieldValue("protocol",value.value)}
                  className="search-select"
                  classNamePrefix="select"
                  isDisabled={(formik.values.type == "FAX")}
                  placeholder="Select Delivery Protocol..."
                  value={getSelected(protocols, formik.values.protocol)}
                  />
            </Col>
        </Row>)}
        {!isFax && (<Row>
          <Col xs lg="2">
            <label className="searchSelectLabel">
              Host Name
            </label>
          </Col>
          <Col>
                    <TextInput
                      keyField={"hostName"}
                      formik={formik}
                      placeholder={"Host Name"}                                               
                      hideRequired={true}
                      required={false}
                      disabled={(formik.values.type == "FAX")}
                      style={{width: "50%"}}
          />
          </Col>
        </Row>)}
        {!isFax && (<Row>
          <Col xs lg="2">
            <label className="searchSelectLabel">
              Username
            </label>
          </Col>
          <Col>
                    <TextInput
                      keyField={"userName"}
                      formik={formik}
                      placeholder={"Username"}                                               
                      hideRequired={true}
                      required={false}
                      style={{width: "50%"}}
          />
          </Col>
        </Row>)}
        {!isFax && (<Row>
          <Col xs lg="2">
            <label className="searchSelectLabel">
              Secret
            </label>
          </Col>
          <Col>
                    <TextInput
                      keyField={"secret"}
                      formik={formik}
                      placeholder={"Secret"}                                               
                      hideRequired={true}
                      required={false}
                      type="password"
                      style={{width: "50%"}}
          />
          </Col>
        </Row>)}
        <Row>
          <Col xs lg="2">
            {!isFax ? <label className="searchSelectLabel">
              Target<span style={{ color: "red" }}> *</span>{" "}
            </label> : <label className="searchSelectLabel">
              FAX Number (11 - digits):
            </label>}
          </Col>
          <Col>
                    {!isFax ? <TextInput
                      keyField={"target"}
                      formik={formik}
                      placeholder={"Report Target"}                                               
                      hideRequired={false}
                      required={true}
                      style={{width: "50%"}}
                    /> : 
                    <TextInput
                      keyField={"target"}
                      formik={formik}
                      placeholder={"Fax number"}                                               
                      hideRequired={false}
                      required={true}
                      style={{width: "200px"}}
                    />}
          </Col>
        </Row>
        <Row style = {{marginBottom:'30px', marginTop: '20px'}}>
          <Col xs lg="2">
                <label className="searchSelectLabel">
                  File Type<span style={{ color: "red" }}> *</span>{" "}
                </label>
          </Col>
          <Col xs lg="4">
              <Select
                  keyField={"fileType"}
                  formik={formik}
                  label={"Select File Type"}
                  selectLabel="Select File Type"
                  options={fileTypes}
                  className="search-select"
                  classNamePrefix="select"
                  placeholder="Select File Type..."
                  onChange={value => formik.setFieldValue("fileType", value.value)}
                  value={getSelected(fileTypes, formik.values.fileType)}
                  />
            </Col>
        </Row>
        <div className="btn-wrap" style={{ display: "flex", marginTop: "45px" }}>
             <Button
              onClick={() =>
                  navigate("/app/report-deliveries", {state: {orgId }})
              }
              variant="secondary"
              title="Cancel"
            >
              Cancel
            </Button>
            <Button type="submit" onClick={() => {
                 console.log(formik.errors)
                 return true;
              }} isLoading={btnLoading}>
              Save
            </Button>
          </div>
        </form>
      </div>
    </section>
  )
}

export default EditReportDelivery;
